import { Spinner } from "components";
import { TimedMessage } from "components/TimedMessage";
import { BulkEditManagedStock } from "models/daoModels/managedStock/BulkEditManagedStock";
import { ManagedSubdepartment } from "models/dbModels/managedSubdepartments/ManagedSubdepartment";
import { useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { cleanBulkEditDetails, updateBulkEditField } from "redux/slices/BulkEdit";
import { getDepartments } from "redux/slices/Departments";
import { bulkUpdate } from "redux/slices/Stocks";
import { getSubDepartments } from "redux/slices/SubDepartment";
import { showToast } from "redux/slices/Toasts";
import { RootState } from "redux/store";


import { getDepartmentStocks, updateDepartmentField } from "redux/slices/PageMemory/StocksDepartmentPageSlice";

type BulkEditProps = {
    show: boolean;
    handleClose: () => void;
}

export function BulkEdit(props: BulkEditProps) {
    const dispatch = useAppDispatch();
    const [canSave, setCanSave] = useState(false);
    const bulkEdit = useAppSelector((state: RootState) => state.bulkEdit);
    const department = useAppSelector((state: any) => state.department);
    const departments = useAppSelector((state: RootState) => state.department);
    const subDepartments = useAppSelector((state: RootState) => state.subDepartment);
    const [subDepartmentList, setSubDepartmentList] = useState<ManagedSubdepartment[]>([]);
    const stockDepartmentPageSlice = useAppSelector((state: RootState) => state.stockDepartmentPageSlice);

    useEffect(() => {
        if (props.show) {
            dispatch(cleanBulkEditDetails());
            dispatch(getDepartments());
        }
    }, [props.show]);

    useEffect(() => {
        if (bulkEdit.subDepartment !== 0 || bulkEdit.department !== 0) {
            setCanSave(true);
        } else {
            setCanSave(false);
        }
    }, [bulkEdit]);

    useEffect(() => {
        if (bulkEdit.department) dispatch(getSubDepartments(bulkEdit.department)).then((res) => {
            if (res.data) setSubDepartmentList(res.data);
        });
    }, [bulkEdit.department]);

    function getSelectedStocks() {
        let selectedStocks: any = [];
        if (stockDepartmentPageSlice.selectAllFilter) {

        } else {
            stockDepartmentPageSlice.selectedStockRows.forEach((rowIndex: any) => rowIndex.forEach((stock: any) =>{
                selectedStocks.push(stock.id);
            }));
        }
        return selectedStocks;
    }

    function handleChange(key: string, value: any) {
        dispatch(updateBulkEditField({ key: key, value: value }));
    }

    function selectedStocksCount() {
        let count = 0;
        if (stockDepartmentPageSlice.selectAllFilter) {
            let deselectedRows = 0;
            stockDepartmentPageSlice.deselectedStockRows.forEach((row: any) => deselectedRows += row.length);
            count = stockDepartmentPageSlice.totalRows - deselectedRows;
        } else {
            stockDepartmentPageSlice.selectedStockRows.forEach((row: any) => row.forEach(() => count++));
        }
        return count;
    }

    function getDeselectedRows() {
        let deselectedRows: any = [];
        stockDepartmentPageSlice.deselectedStockRows.forEach((rowIndex: any) => rowIndex.forEach((stock: any) => deselectedRows.push(stock.id)));
        return deselectedRows;
    }

    function handleBulkUpdate() {
        let selectedStocksList = getSelectedStocks();
        handleChange("loading", true);
        let selectedRows: number[] = [];
        subDepartments.selectedRows.forEach((selectedRow: any) => {
            subDepartments.table.map((item: any, index: number) => {
                if (parseInt(selectedRow) === index) {
                    const { id } = subDepartments.table[index];
                    selectedRows.push(id);
                }
            });
        });

        let bulkUpdateParams: BulkEditManagedStock = {
            filter: {
                keyword: stockDepartmentPageSlice.stocksKeyword,
                contains: true,
                ids: (stockDepartmentPageSlice.selectAllFilter ? [] : selectedStocksList),
                excludedIds: (stockDepartmentPageSlice.selectAllFilter ? getDeselectedRows() : []),
                departmentIds: [stockDepartmentPageSlice.id],
                subdepartmentIds: selectedRows
            },
            department: (bulkEdit.department ? {
                isChanging: true,
                newValue: bulkEdit.department,
                oldValue: null,
            } : undefined),
            subDepartment: (bulkEdit.subDepartment ? {
                isChanging: true,
                newValue: bulkEdit.subDepartment,
                oldValue: null,
            } : undefined),
        };
        dispatch(bulkUpdate(bulkUpdateParams)).then((res) => {
            if (res.data) {
                dispatch(showToast({ value: [`Bulk Edit Successful for ${selectedStocksCount()} Stocks`] }));
                reloadDepartmentStock();
            }
            dispatch(updateDepartmentField({ key: "deselectedStockRows", value: [] }));
            dispatch(updateDepartmentField({ key: "selectedStockRows", value: [] }));
            dispatch(updateDepartmentField({ key: "selectAllFilter", value: false }));
            handleChange("loading", false);
            props.handleClose();
        });
    }

    function reloadDepartmentStock(keyword: string | undefined = undefined, subdepartments: number[] | undefined = undefined, offset: number | undefined = undefined, limit: number | undefined = undefined) {
        let selectedSubDepartments: any[] = [];
        subDepartments.selectedRows.forEach((selectedRow: any) => {
            subDepartments.table.map((item: any, index: number) => {
                if (parseInt(selectedRow) === index) {
                    const { id } = subDepartments.table[index];
                    selectedSubDepartments.push(id);
                }
            });
        });

        dispatch(getDepartmentStocks({
            keyword: keyword || stockDepartmentPageSlice.stocksKeyword,
            departmentIds: [stockDepartmentPageSlice.id],
            subdepartmentIds: subdepartments || selectedSubDepartments,
            offset: offset || (stockDepartmentPageSlice.pageIndex * stockDepartmentPageSlice.pageSize),
            limit: limit || stockDepartmentPageSlice.pageSize,
        }));
    }

    return (
        <Modal size="lg" centered show={props.show} backdrop={bulkEdit.loading ? "static" : true} onHide={props.handleClose} className="modal-mdlg">
            <Modal.Header closeButton={!bulkEdit.loading}>
                <Modal.Title>Bulk Edit - {selectedStocksCount()} Stocks Selected</Modal.Title>
            </Modal.Header>
            <Modal.Body className={`${bulkEdit.loading && "disabled-div"}`}>
                <Row className="mt-2 mb-2">
                    <Col xs={5}><Form.Label>Department</Form.Label></Col>
                    <Col xs={7}>
                        <Form.Group>
                            <Form.Select className="custom-select"
                                value={bulkEdit.department}
                                onChange={(e) => {
                                    handleChange("department", parseInt(e.target.value));
                                    if (parseInt(e.target.value) === 0) handleChange("subDepartment", 0);
                                }}
                            >
                                <option value="0"> </option>
                                {departments.table.map((department: any, index: any) => {
                                    return <option key={index} value={department.id}>{department.name}</option>
                                })}
                            </Form.Select>
                        </Form.Group>
                    </Col>
                </Row>
                <Row className="mt-2 mb-2">
                    <Col xs={5}><Form.Label>Sub Department</Form.Label></Col>
                    <Col xs={7}>
                        <Form.Group>
                            <Form.Select className="custom-select"
                                value={bulkEdit.subDepartment}
                                onChange={(e) => handleChange("subDepartment", parseInt(e.target.value))}
                            >
                                <option value="0"> </option>
                                {bulkEdit.department !== 0 && <>
                                    {subDepartmentList.map((subDepartment: any, index: any) => {
                                        return <option key={index} value={subDepartment.id}>{subDepartment.name}</option>
                                    })}
                                </>}
                            </Form.Select>
                        </Form.Group>
                    </Col>
                </Row>
                <Row className="mt-3">
                    <Col lg={12} className="d-flex flex-row-reverse">
                        {canSave &&
                            <Button variant="primary" className="btn ms-1 d-flex cta-button" disabled={bulkEdit.loading} onClick={handleBulkUpdate}>
                                {bulkEdit.loading ? <><Spinner className="spinner-border-sm me-1" tag="span" color="white" /></> : <></>}
                                {bulkEdit.loading ? <>Saving...</> : <>Save</>}
                            </Button>
                        }
                        <Button variant="secondary" className="btn ms-1 cta-button" disabled={bulkEdit.loading} onClick={() => props.handleClose()}>Cancel</Button>
                        <TimedMessage message="Please wait while we edit all your data..." delay={30} enabled={bulkEdit.loading} className="mb-0 py-1 px-2" />
                    </Col>
                </Row>
            </Modal.Body>
        </Modal>
    );
}